import React from 'react';

export default function Contact() {
  return (
    <section id="contact" className="bg-[#FBF0DC] text-[#0062AD]" aria-labelledby="contact-heading">
      <div className="mx-auto flex max-w-[1200px] flex-col items-center px-[clamp(20px,5vw,72px)] py-[clamp(48px,9vw,84px)] text-center">
        <h2
          id="contact-heading"
          className="m-0 font-extrabold leading-[1.06] tracking-[-0.015em] text-[clamp(34px,4.2vw,56px)]"
        >
          Let's connect.
        </h2>
        <p className="mt-5 max-w-[48ch] text-[17px] opacity-90">
          Feel free to reach out. I'm always open to talking about new projects, roles, or ideas.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-4">
          <a href="https://www.linkedin.com/in/liuweiluo/" target="_blank" rel="me noopener noreferrer">
            <button type="button" className="btn btn-invert">LinkedIn</button>
          </a>
          <a href="https://github.com/qian-27" target="_blank" rel="me noopener noreferrer">
            <button type="button" className="btn btn-invert">GitHub</button>
          </a>
        </div>
      </div>
    </section>
  );
}
